// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TspN","toggle":"styles_toggle__KjQfl","preview":"styles_preview__14dai"};